import type { SVGProps } from "react";
const SvgDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 21 21"
    fontSize="1rem"
    {...props}
  >
    <g clipPath="url(#dashboard_svg__a)">
      <path
        fill="currentColor"
        d="M7.335 11.08a2.476 2.476 0 0 1 2.222 2.461v4.608l-.013.253a2.48 2.48 0 0 1-2.209 2.21l-.253.012H2.474l-.253-.013a2.476 2.476 0 0 1-2.21-2.209L0 18.15v-4.608a2.475 2.475 0 0 1 2.475-2.475h4.608zm11.066 0a2.476 2.476 0 0 1 2.222 2.461v4.608l-.013.253a2.48 2.48 0 0 1-2.209 2.21l-.253.012H13.54l-.253-.013a2.476 2.476 0 0 1-2.209-2.209l-.013-.253v-4.608a2.475 2.475 0 0 1 2.475-2.475h4.608zm-4.861 1.586a.876.876 0 0 0-.875.875v4.608c0 .483.392.874.875.874h4.608a.875.875 0 0 0 .875-.874v-4.608a.875.875 0 0 0-.875-.875zm-11.066 0a.876.876 0 0 0-.875.875v4.608c0 .483.392.874.875.874h4.608a.874.874 0 0 0 .874-.874v-4.608a.875.875 0 0 0-.874-.875zM7.335.013a2.476 2.476 0 0 1 2.222 2.462v4.608l-.013.253a2.48 2.48 0 0 1-2.209 2.209l-.253.013H2.474l-.253-.013a2.476 2.476 0 0 1-2.21-2.21L0 7.084V2.475A2.475 2.475 0 0 1 2.474 0h4.608zM15.844 0a4.78 4.78 0 0 1 4.779 4.778l-.007.246a4.78 4.78 0 0 1-4.772 4.534l-.245-.007A4.78 4.78 0 0 1 15.844 0M2.474 1.6a.876.876 0 0 0-.875.875v4.608c0 .483.392.874.875.874h4.608a.874.874 0 0 0 .874-.874V2.475a.875.875 0 0 0-.874-.875zm13.37 0a3.18 3.18 0 1 0 .001 6.358 3.18 3.18 0 0 0-.001-6.358"
      />
    </g>
    <defs>
      <clipPath id="dashboard_svg__a">
        <path fill="#fff" d="M0 0h20.624v20.624H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDashboard;
